<template>
  <div
    :style="[ iconName == 'print' ? 'width:56px' : '',
              className === '' ? 'background-color:#86A4C6' : '' ]"
    :class="['menu-item', 'ml-1', className]"
    @click="$emit('click')"
  >
    <div class="menu-dots gap-x-2 justify-center">
      <div class="dot bg-white rounded-full"></div>
      <div class="dot bg-white rounded-full"></div>
      <div class="dot bg-white rounded-full"></div>
    </div>
    <div class="flex justify-center mt-3">
      <HomeIcn
        class="filter invert-0 opacity-50"
        v-if="iconName == 'home'"
        width="26px"
        height="26px"
        fill-rule="evenodd"
        fill="black"
      />
      <LightningIcn
        class="filter invert-0 opacity-50"
        v-if="iconName == 'lightning'"
        width="26px"
        height="26px"
        fill="black"
      />
      <ReceiptIcn
        class="filter invert-0 opacity-50"
        v-if="iconName == 'receipt'"
        width="26px"
        height="26px"
        fill-rule="evenodd"
        fill="black"
      />
      <MoneyIcn
        class="filter invert-0 opacity-50"
        v-if="iconName == 'money-circle'"
        width="26px"
        height="26px"
        fill-rule="evenodd"
        fill="black"
      />
      <NotificationIcn
        class="filter invert-0 opacity-50"
        v-if="iconName == 'notification'"
        width="26px"
        height="26px"
        fill-rule="evenodd"
        fill="black"
      />
      <TimelineIcn
        class="filter invert-0 opacity-50"
        v-if="iconName == 'timeline'"
        width="26px"
        height="26px"
        fill-rule="evenodd"
        fill="black"
      />
      <PrintIcn
        class="filter invert-0 opacity-50"
        v-if="iconName == 'print'"
        width="26px"
        height="26px"
        fill-rule="evenodd"
        fill="black"
      />
      <UserIcn
        class="filter invert-0 opacity-50"
        v-if="iconName == 'user'"
        width="26px"
        height="26px"
        fill-rule="evenodd"
        fill="black"
      />
    </div>
    <div class="flex justify-center mt-1">
      <span
        class="text-center text-lg text-black text-opacity-50 font-bold menu-title"
        >{{ title }}</span
      >
    </div>
    <div class="flex justify-center">
      <span
        class="-mt-1 text-center text-xs text-black text-opacity-50 font-bold menu-title"
      >
        {{ subtitle }}</span
      >
    </div>
  </div>
</template>

<script>
import HomeIcn from '@/assets/icons/home.svg?inline'
import ReceiptIcn from '@/assets/icons/receipt.svg?inline'
import MoneyIcn from '@/assets/icons/money-circle.svg?inline'
import NotificationIcn from '@/assets/icons/notification.svg?inline'
import LightningIcn from '@/assets/icons/lightning-new.svg?inline'
import TimelineIcn from '@/assets/icons/timeline.svg?inline'
import PrintIcn from '@/assets/icons/print.svg?inline'
import UserIcn from '@/assets/icons/user-not-circle.svg?inline'

export default {
  name: 'AppHeaderMenuItem',

  components: {
    HomeIcn,
    ReceiptIcn,
    MoneyIcn,
    NotificationIcn,
    LightningIcn,
    TimelineIcn,
    PrintIcn,
    UserIcn
  },

  props: {
    className: String,
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    iconName: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.menu-item {
  width: 96px;
  height: 96px;
  border-radius: 0 0 48px 48px;
  cursor: pointer;
  &.active {
    height: 114px;
    transition: ease-in-out 0.2s;

    .menu-title {
      color: #fff !important;
    }

    svg {
      filter: invert(0) !important;
      fill: white !important;
      opacity: 1 !important;
    }

    .menu-dots {
      display: flex;
    }
  }

  .menu-dots {
    display: none;
    animation: show 0.2s linear 0s;
    margin-top: 10px;
  }

  .dot {
    width: 8px;
    height: 8px;
    content: '';
  }
}
</style>
